import React from "react";
import { Switch } from "@chakra-ui/react";
import { RichTextEditor } from "newui/components/ui/RichTextEditor";

interface AdditionalTextPanelProps {
	additionalText: string;
	includeAdditionalText: boolean;
	onAdditionalTextChange: (text: string) => void;
	onIncludeAdditionalTextChange: (include: boolean) => void;
}

const AdditionalTextPanel: React.FC<AdditionalTextPanelProps> = ({
	additionalText,
	includeAdditionalText,
	onAdditionalTextChange,
	onIncludeAdditionalTextChange,
}) => {
	return (
		<div className="rounded-lg border border-gray-200 p-4">
			<div className="mb-3 flex items-center justify-between">
				<div>
					<h3 className="text-sm font-semibold uppercase tracking-wide text-gray-700">
						Additional Text Page
					</h3>
					<p className="text-xs text-gray-500">
						Add a page with context about this shortlist evaluation.
					</p>
				</div>
				<Switch
					isChecked={includeAdditionalText}
					onChange={(e) => onIncludeAdditionalTextChange(e.target.checked)}
					colorScheme="blue"
					size="md"
				/>
			</div>

			{includeAdditionalText && (
				<div>
					<RichTextEditor
						value={additionalText}
						onChange={onAdditionalTextChange}
						placeholder="Describe the purpose of this shortlist report..."
						minHeight="150px"
					/>
					<p className="mt-1 text-right text-xs text-gray-400">
						{additionalText.replace(/<[^>]*>/g, "").length} / 2000 characters
					</p>
				</div>
			)}
		</div>
	);
};

export default AdditionalTextPanel;
